import { Box, Button, Card, Typography } from '@mui/joy'
import React, { useEffect, useState } from 'react'
import ReactQuill from 'react-quill'
import { post, Token } from '../../../Script/Session';
import { useNavigate } from 'react-router-dom';
import ElementBeschlussbuch from './ElementBeschlussbuch';

function EditPanel({ data, update, del, edit }) {
  const [value, setvalue] = useState("");
  const navigate = useNavigate();
  const toolbarModules = {
    toolbar: [
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      ['link', 'image'],
      ['clean']
    ]
  };
  const modulesWithEnter = {
    ...toolbarModules,
    keyboard: {
      bindings: {
        handleEnter: {
          key: 13,
          handler: function (range, context) {
            const quill = this.quill;
            // insert a line break inside current block
            quill.insertText(range.index, '\n', 'user');
            quill.setSelection(range.index + 1, 0);
          }
        }
      }
    }
  };
  function set() {
    let body = {};
    body.token = Token.get();
    body.message = value;
    body.action = "add";
    console.log(body);
    let response = post(body, "/beschlussbuch");
    if (response == "LOGOUT") {
      navigate("/");
    }
    if (response == "OK") {
      alert("Hinzugefügt!")
      window.location.reload();
      setvalue("");
    }
  }
  const [quill, setquill] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setquill(true);
    }, 250);
  }, []);
  return (
    <>

      <Card variant='soft' sx={{ mt: 1, bgcolor: "white" }}>
        <Typography level="title-md">Eintrag hinzufügen</Typography>
        <Typography sx={{ mt: -1.2 }}>Geben sie im unten angegebenen Feld ihren Eintrag ein</Typography>

        <ReactQuill
          defaultValue={value}
          
          onChange={(e) => setvalue(e)}
          modules={!quill ? { toolbar: false } : modulesWithEnter}
          style={{ backgroundColor: "white", height: "350px" }}
          preserveWhitespace={quill}
        />

        <Button sx={{ width: "15%", mt: 13 }} onClick={() => set()}>Hinzufügen</Button>
      </Card>

      {
        data && data.result.slice().sort((a, b) => b.stamp - a.stamp).map((item) => {
          return (
            <ElementBeschlussbuch item={item} edit={true} del={del} update={update} showToolbar={false} />
          )


        })
      }

    </>
  )
}

export default EditPanel
